interface BlockCheckCache {
  blocked: boolean;
  timestamp: number;
}

const CACHE_TTL = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
const CACHE_KEY_PREFIX = 'blockCheck_';

export function getBlockCheckCache(address: string): BlockCheckCache | null {
  if (!import.meta.client || !address) return null;

  try {
    const cached = localStorage.getItem(`${CACHE_KEY_PREFIX}${address.toLowerCase()}`);
    if (!cached) return null;

    const data: BlockCheckCache = JSON.parse(cached);
    const now = Date.now();

    // Check if cache is expired
    if (now - data.timestamp > CACHE_TTL) {
      localStorage.removeItem(`${CACHE_KEY_PREFIX}${address.toLowerCase()}`);
      return null;
    }

    return data;
  } catch {
    return null;
  }
}

export function setBlockCheckCache(address: string, blocked: boolean): void {
  if (!process.client || !address) return;

  try {
    const data: BlockCheckCache = {
      blocked,
      timestamp: Date.now()
    };
    localStorage.setItem(`${CACHE_KEY_PREFIX}${address.toLowerCase()}`, JSON.stringify(data));
  } catch {
    // Ignore write errors
  }
}
